export * from './details-modal';
